module.exports = __webpack_public_path__ + "static/media/sports_10.02dbe512.jpg";